<template>
  <el-dialog
    :title="isUpdate ? '修改法币' : '添加法币'"
    :visible="visible"
    :width="isUpdate ? '750px' : '480px'"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form v-if="!isUpdate" ref="form" :model="form" :rules="addRules" label-width="100px">
      <el-form-item label="国家/地区:" prop="country_id">
        <el-select
          v-model="form.country_id"
          clearable
          filterable
          class="ele-fluid"
          placeholder="请选择"
          :loading="countryLoading">
          <el-option v-for="item in availableCountryList" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
    </el-form>
    <el-form v-else ref="form" :model="form" :rules="editRules" label-width="100px">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="国家/地区" prop="country">
            <el-input clearable :maxlength="100" v-model.trim="form.country" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="币种名称" prop="name">
            <el-input clearable :maxlength="100" v-model.trim="form.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" class="ele-fluid" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="国家编码" prop="country_code">
            <el-input clearable :maxlength="10" v-model.trim="form.country_code" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="币种代码" prop="code">
            <el-input clearable :maxlength="3" v-model.trim="form.code" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="2" resize="none" placeholder="请输入" maxlength="255" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

const defaultAddForm = () => ({ country_id: '' });
const defaultEditForm = () => ({ country: '', country_code: '', name: '', code: '', status: 1, sort: 0, note: '' });

export default {
  name: 'FiatCurrencyEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultAddForm(),
      addRules: {
        country_id: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editRules: {
        country: [{ required: true, message: '请输入', trigger: 'blur' }],
        country_code: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      countryList: [],
      existingCountries: [],
      countryLoading: false,
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  computed: {
    availableCountryList() {
      const exists = new Set(this.existingCountries);
      return this.countryList.filter((item) => !exists.has(item.name));
    }
  },
  watch: {
    data() {
      this.initForm();
    },
    visible(val) {
      if (val && !this.isUpdate) {
        this.loadCountryOptions();
      }
    }
  },
  methods: {
    initForm() {
      if (this.data) {
        this.form = Object.assign(defaultEditForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultAddForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    loadCountryOptions() {
      this.countryLoading = true;
      Promise.all([
        this.$http.get('/CountryRegion/getCountryRegionList'),
        this.$http.get('/FiatCurrency/getFiatCurrencyList')
      ]).then(([countryRes, fiatRes]) => {
        this.countryLoading = false;
        if (countryRes.data.code === 0) {
          this.countryList = countryRes.data.data || [];
        } else {
          this.$message.error(countryRes.data.msg);
        }
        if (fiatRes.data.code === 0) {
          this.existingCountries = (fiatRes.data.data || []).map((item) => item.country);
        }
      }).catch((e) => {
        this.countryLoading = false;
        this.$message.error(e.message);
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        const payload = this.isUpdate ? this.form : { country_id: this.form.country_id };
        this.$http.post('/FiatCurrency/edit', payload).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
